import React, { Component } from 'react';

class SVGSprite extends Component {
  render() {
    return (
      <svg className="hide">

        <symbol id="logo" viewBox="0 0 9.87 13.95">
          <path d="M5.64,7A1.33,1.33,0,1,0,7,5.64,1.33,1.33,0,0,0,5.64,7S5.64,7,5.64,7Zm1.3.7a.71.71,0,0,1-.7-.7.71.71,0,0,1,1.42,0s0,0,0,0A.75.75,0,0,1,6.94,7.67ZM5.07,7m.37-5.15h3a.32.32,0,0,0,0-.63h-3a.32.32,0,1,0,0,.63Zm0,1.49h3a.32.32,0,0,0,0-.63h-3a.32.32,0,1,0,0,.63Zm0,1.48h3a.32.32,0,0,0,0-.63h-3a.32.32,0,1,0,0,.63ZM4.94,11,3.57,12.35a.37.37,0,0,1-.63-.26V0L0,2.48V13.64a.31.31,0,0,0,.31.31H6.87l3-3Z"/>
        </symbol>

        <symbol id="plus" viewBox="0 0 512 512">
          <path d="M256,0C114.8,0,0,114.9,0,256c0,141.1,114.8,256,256,256c141.1,0,256-114.9,256-256C512,114.9,397.1,0,256,0z M256,464.5
          	C141,464.5,47.5,371,47.5,256C47.5,141,141,47.5,256,47.5S464.5,141,464.5,256C464.5,371,371,464.5,256,464.5z M373.5,234.2h-95.7
          	v-95.7c0-12-9.7-21.8-21.7-21.8c-12,0-21.8,9.7-21.8,21.8v95.7h-95.7c-12,0-21.7,9.7-21.7,21.8c0,12,9.7,21.7,21.7,21.7h95.7v95.7
          	c0,12,9.7,21.7,21.8,21.7c12,0,21.8-9.7,21.8-21.7v-95.7h95.7c12,0,21.8-9.7,21.8-21.7C395.2,244,385.5,234.2,373.5,234.2z"/>
        </symbol>

        <symbol id="clock" viewBox="0 0 20 20">
          <path d="M10,18.3c-4.6,0-8.3-3.7-8.3-8.3S5.4,1.7,10,1.7s8.3,3.7,8.3,8.3S14.5,18.3,10,18.3 M10,0.2
          	c-5.4,0-9.8,4.4-9.8,9.8s4.4,9.8,9.8,9.8s9.8-4.4,9.8-9.8S15.4,0.2,10,0.2 M10.9,9.1V5c0-0.4-0.3-0.7-0.6-0.7C10,4.3,9.7,4.6,9.7,5
          	v4.4c0,0.2,0.1,0.4,0.2,0.5l2.5,2.9c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2c0.2-0.3,0.2-0.7,0-1L10.9,9.1z" />
        </symbol>

        <symbol id="lock-filled" viewBox="0 0 80 80">
            <path d="M61.5,40V36.92a11.5,11.5,0,0,0-23,0V40A3.82,3.82,0,0,0,35,43.82V61.18A3.82,3.82,0,0,0,38.82,65H61.18A3.82,3.82,0,0,0,65,61.18V43.82A3.82,3.82,0,0,0,61.5,40ZM51.25,54.28v4.33a.4.4,0,0,1-.39.39H49.14a.4.4,0,0,1-.39-.39V54.28a4,4,0,1,1,2.5,0ZM57.5,40h-15V36.92a7.5,7.5,0,0,1,15,0Z"/>
        </symbol>

        <symbol id="lock" viewBox="0 0 18 21.3">
          <path d="M9,11.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.6,0.3,1.1,0.8,1.4v2.3c0,0.2,0.2,0.4,0.4,0.4h0.9c0.2,0,0.4-0.2,0.4-0.4 v-2.3c0.5-0.3,0.8-0.8,0.8-1.4C10.6,12.2,9.9,11.5,9,11.5 M16.4,19.5c0,0.1-0.1,0.2-0.2,0.2H1.8c-0.1,0-0.2-0.1-0.2-0.2V8.4 c0-0.1,0.1-0.2,0.2-0.2h2.3h9.8h2.3c0.1,0,0.2,0.1,0.2,0.2V19.5z M4.9,5.7c0-2.3,1.8-4.1,4.1-4.1s4.1,1.8,4.1,4.1v0.8H4.9V5.7z M16.2,6.5h-1.5V5.7C14.7,2.6,12.2,0,9,0S3.3,2.6,3.3,5.7v0.8H1.8C0.8,6.5,0,7.4,0,8.4v11.1c0,1,0.8,1.8,1.8,1.8h14.4 c1,0,1.8-0.8,1.8-1.8V8.4C18,7.4,17.2,6.5,16.2,6.5z" />
        </symbol>

        <symbol id="star" viewBox="0 0 27.4 26.1">
          <path d="M13.7,0l-3.2,10H0l8.5,6.1l-3.3,10l8.5-6.2l8.5,6.2l-3.3-10l8.5-6.1H16.9L13.7,0z"/>
        </symbol>

        <symbol id="arrow-right" viewBox="0 0 18 30">
          <path d="M1.8,0.3C2,0.1,2.2,0,2.5,0C2.8,0,3,0.1,3.2,0.3l14,14c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7
            l-14,14C3,29.9,2.8,30,2.5,30c-0.3,0-0.5-0.1-0.7-0.3l-1.5-1.5C0.1,28,0,27.8,0,27.5s0.1-0.5,0.3-0.7L12.1,15L0.3,3.2
            C0.1,3,0,2.8,0,2.5C0,2.2,0.1,2,0.3,1.8L1.8,0.3z"/>
        </symbol>

        <symbol id="arrow-left" viewBox="0 0 18 30">
          <path d="M1.8,0.3 C2,0.1 2.2,0 2.5,0 C2.8,0 3,0.1 3.2,0.3 L17.2,14.3 C17.4,14.5 17.5,14.7 17.5,15 C17.5,15.3 17.4,15.5 17.2,15.7 L3.2,29.7 C3,29.9 2.8,30 2.5,30 C2.2,30 2,29.9 1.8,29.7 L0.3,28.2 C0.1,28 0,27.8 0,27.5 C0,27.2 0.1,27 0.3,26.8 L12.1,15 L0.3,3.2 C0.1,3 0,2.8 0,2.5 C0,2.2 0.1,2 0.3,1.8 L1.8,0.3 Z" id="arrow-left" fillRule="nonzero" transform="translate(8.750000, 15.000000) scale(-1, 1) translate(-8.750000, -15.000000) "></path>
        </symbol>

        <symbol id="magnifying-glass" viewBox="0 0 30 30">
          <path id="path-1_1_" d="M22,19.4l7.4,7.4c0.7,0.7,0.7,1.9,0,2.7s-1.9,0.7-2.7,0L19.4,22c-2,1.5-4.5,2.3-7.2,2.3
            C5.5,24.4,0,18.9,0,12.2S5.5,0,12.2,0s12.2,5.5,12.2,12.2C24.4,14.9,23.5,17.4,22,19.4z M20.6,12.2c0-4.7-3.8-8.4-8.4-8.4
            s-8.4,3.8-8.4,8.4s3.8,8.4,8.4,8.4S20.6,16.8,20.6,12.2z"/>
        </symbol>

        <symbol id="share" viewBox="0 0 96 96">
          <path d="M67.5,18c-5.1,0-9.3,4.2-9.3,9.3c0,0.5,0.1,1.1,0.2,1.6l-23,12.9c-1.7-1.8-4.1-3-6.8-3
          	c-5.1,0-9.3,4.1-9.3,9.3c0,5.1,4.1,9.3,9.3,9.3c2.7,0,5.2-1.2,6.9-3.1l22.8,13.4c0,0.4-0.1,0.7-0.1,1.1c0,5.1,4.1,9.3,9.3,9.3
          	c5.1,0,9.3-4.1,9.3-9.3c0-5.1-4.1-9.3-9.3-9.3c-2.8,0-5.4,1.3-7.1,3.3L37.7,49.4c0.1-0.4,0.1-0.9,0.1-1.3c0-0.5,0-1-0.1-1.5l23.1-13
          	c1.7,1.8,4.1,3,6.8,3c5.1,0,9.3-4.1,9.3-9.3C76.8,22.2,72.6,18,67.5,18L67.5,18z"/>
        </symbol>

        <symbol id="hudl" viewBox="0 0 29.1 29.1">
          <path d="M14.6,28.9c-2.3,0-4.3-1.6-4.8-3.8c0,0,0-0.1-0.1-0.1c-0.6-0.3-1.3-0.6-1.9-0.9c0,0,0,0,0,0
          	c-0.9-2.3-1.1-4.7-0.6-7.1c0,0,0-0.1,0.1-0.1h0c0,0,0.1,0,0.1,0c1.2,1.3,2.7,2.3,4.3,3.1c0,0,0,0,0,0c0,0,0,0,0.1,0
          	c2.1-1.5,5.1-1.1,6.7,1c0,0,0,0,0.1,0h0c0.4-0.1,0.9-0.1,1.4-0.3c2.7-0.7,5.1-2.1,6.9-4.2c0,0,0,0,0.1,0c0,0,0,0,0,0
          	c0,0,0.1,0.1,0,0.1c-1.1,3.8-3.9,6.9-7.5,8.5c0,0,0,0-0.1,0.1C18.9,27.3,16.9,28.9,14.6,28.9z M5.4,22.1C5.4,22.1,5.4,22.1,5.4,22.1
          	c-2.9-2.9-4.2-6.8-3.6-10.8c0,0,0-0.1,0-0.1c-1.7-1.6-2-4.1-0.9-6S4.3,2.3,6.5,3c0,0,0.1,0,0.1,0c0.6-0.4,1.1-0.8,1.8-1.2
          	c0,0,0,0,0,0c2.4,0.4,4.7,1.4,6.5,3c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c-1.7,0.4-3.4,1.1-4.8,2.2c0,0,0,0.1,0,0.1c0,0.2,0,0.3,0,0.5
          	c0,2.4-1.8,4.5-4.2,4.9c0,0-0.1,0-0.1,0.1c-0.2,0.4-0.3,0.9-0.5,1.3c-0.8,2.6-0.7,5.5,0.2,8.1C5.5,22,5.5,22.1,5.4,22.1
          	C5.5,22.1,5.5,22.1,5.4,22.1L5.4,22.1z M21.6,17.5C21.5,17.5,21.5,17.5,21.6,17.5c-0.1-0.1-0.1-0.1-0.1-0.1c0.5-1.7,0.7-3.4,0.5-5.2
          	c0,0,0-0.1-0.1-0.1c-1.7-0.8-2.8-2.5-2.9-4.5c0-0.6,0.1-1.3,0.4-1.9c0,0,0-0.1,0-0.1c-0.3-0.4-0.6-0.8-0.9-1.1
          	c-1.9-2-4.4-3.3-7.1-3.9c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0.1-0.1c3.9-1,8-0.1,11.1,2.4c0,0,0,0,0.1,0c0,0,0,0,0,0
          	c0.4-0.1,0.9-0.2,1.4-0.2c2,0,3.8,1.2,4.6,3.1c0.7,1.9,0.3,4-1.2,5.4c0,0,0,0,0,0.1c0.1,0.6,0.1,1.1,0.1,1.7c0,0.1,0,0.1,0,0.2
          	l0,0.1c0,0,0,0,0,0.1C25.9,15.3,23.9,16.7,21.6,17.5L21.6,17.5z"/>
        </symbol>

        <symbol id="twitter" viewBox="0 0 16 13">
          <path d="M15.5,2c-0.4,0.6-1,1.2-1.6,1.6c0,0.1,0,0.2,0,0.4c0,0.8-0.1,1.7-0.4,2.5S12.9,8.2,12.4,9s-1.1,1.5-1.8,2.1
          	s-1.5,1.1-2.5,1.4c-1,0.4-2,0.5-3.2,0.5c-1.8,0-3.4-0.5-4.8-1.4c0.2,0,0.5,0,0.8,0c1.5,0,2.8-0.4,3.9-1.3c-0.7,0-1.3-0.2-1.8-0.6
          	S2,8.7,1.8,8.1c0.2,0,0.4,0,0.6,0c0.3,0,0.6,0,0.8-0.1C2.5,7.9,1.9,7.5,1.4,7s-0.7-1.2-0.7-2v0c0.4,0.2,0.9,0.4,1.4,0.4
          	C1.7,5,1.4,4.6,1.1,4.2c-0.3-0.5-0.4-1-0.4-1.5c0-0.6,0.1-1.1,0.4-1.6c0.8,1,1.7,1.7,2.9,2.3c1.1,0.6,2.3,0.9,3.6,1
          	C7.6,4.1,7.6,3.9,7.6,3.7c0-0.9,0.3-1.6,0.9-2.2c0.6-0.6,1.4-0.9,2.2-0.9c0.9,0,1.7,0.3,2.3,1c0.7-0.1,1.4-0.4,2-0.8
          	c-0.2,0.7-0.7,1.3-1.4,1.7C14.3,2.4,14.9,2.3,15.5,2z"/>
        </symbol>

        <symbol id="facebook" viewBox="0 0 10 17">
          <path d="M9.1,0.1v2.6H7.6C7,2.7,6.7,2.8,6.5,3.1C6.3,3.3,6.2,3.6,6.2,4.1V6H9L8.7,8.9H6.2v7.4h-3V8.9H0.7V6h2.5V3.8
          c0-1.2,0.3-2.2,1-2.8c0.7-0.7,1.6-1,2.7-1C7.9,0,8.6,0,9.1,0.1z"/>
        </symbol>

        <symbol id="instagram" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </symbol>

        <symbol id="close" viewBox="0 0 24.5 24.5">
          <path d="M1.1,2.7c-0.4-0.4-0.4-1.1,0-1.6c0.4-0.4,1.1-0.4,1.6,0l9.5,9.5l9.5-9.5c0.4-0.4,1.1-0.4,1.6,0
          	c0.4,0.4,0.4,1.2,0,1.6l-9.5,9.5l9.5,9.5c0.4,0.4,0.4,1.1,0,1.6c-0.4,0.4-1.1,0.4-1.6,0l-9.5-9.5l-9.5,9.5c-0.4,0.4-1.1,0.4-1.6,0
          	c-0.4-0.4-0.4-1.2,0-1.6l9.5-9.5L1.1,2.7z"/>
        </symbol>

        <symbol id="trash-can" viewBox="0 0 63 72.4">
          <path d="M44.2,10.8V0H18.8v10.8H0v6h6.1v55.6h50.8V16.8H63v-6H44.2z M24.9,5.9h13.3v4.8H24.8L24.9,5.9z M50.9,66.4H12.1V16.8h38.8
            V66.4z M42,59.2h-6V23.3h6V59.2z M27,59.2h-6V23.3h6V59.2z"/>
        </symbol>

      </svg>
    );
  }
}

export default SVGSprite;



// WEBPACK FOOTER //
// ./src/components/Global/SVGSprite.js